import React from "react";
import Header from "@/components/jp/Header";
import Menu from "@/components/jp/Menu";
import Footer from "@/components/jp/Footer";
import FloatingButton from "@/components/jp/FloatingButton";
import ScrollToTopFab from "@/components/jp/ScrollToTopFab";
import Stamping from "@/components/jp/process_usage/Stamping";
import MachiningParts from "@/components/jp/process_usage/MachiningParts";
import ColorAnodized from "@/components/jp/process_usage/ColorAnodized";
import SubProcesses from "@/components/jp/process_usage/SubProcesses";
import PlantInfrastructure from "@/components/jp/process_usage/PlantInfrastructure";
import Link from "next/link";
import Image from "next/image";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CircleIcon from "@mui/icons-material/Circle";
import Stack from "@mui/material/Stack";
import SAbout from "@/public/static/images/opacity_about.png";
import SInstru from "@/public/static/images/opacity_instru.png";
import SNews from "@/public/static/images/opacity_news.png";

const breadcrumbs = [
  <Link key="1" href="/">
    ホーム
  </Link>,
  <Typography key="2">加工・用途紹介</Typography>,
];

function ProcessUsage() {
  return (
    <div className="wrapper">
      <Header />
      <Menu />

      <div className="coverMain">
        <div className="container">
          <div className="row">
            <Grid
              container
              spacing={2}
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item xs={12}>
                <Typography
                  variant="h3"
                  noWrap
                  sx={{
                    mr: 2,
                    mb: 1,
                    fontFamily: "Titillium Web",
                    fontWeight: 800,
                    letterSpacing: ".1rem",
                    color: "#fff",
                    textDecoration: "none",
                  }}
                >
                  <CircleIcon
                    sx={{ mb: 1, mr: 2, fontSize: "18px", color: "#0179CC" }}
                  />
                  加工・用途紹介
                </Typography>
                <Breadcrumbs
                  separator={<NavigateNextIcon fontSize="small" />}
                  aria-label="breadcrumb"
                  className="breadcrumbs"
                >
                  {breadcrumbs}
                </Breadcrumbs>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>

      <div className="content">
        <div className="container">
          <div className="row">
            <div className="link-in_process mb-5 col-12">
              <Stack
                direction={{ xs: "column", md: "row" }}
                spacing={{ xs: 1, sm: 2, md: 2 }}
                alignItems="center"
                justifyContent="center"
                className="stack-inner"
              >
                <div className="process_menu-btn">
                  <Link className="active" href={"#stamping"} scroll={false}>
                    プレス加工品
                  </Link>
                </div>
                <div className="process_menu-btn">
                  <Link href={"#machining"} scroll={false}>
                    切削加工品
                  </Link>
                </div>
                <div className="process_menu-btn">
                  <Link href={"#coloranodized"} scroll={false}>
                    アルマイト着色加工品
                  </Link>
                </div>
                {/* <div className="process_menu-btn">
                  <Link href={"#subprocesses"} scroll={false}>
                    Sub Processes
                  </Link>
                </div> */}
                <div className="process_menu-btn">
                  <Link href={"#plantinfrastructure"} scroll={false}>
                    プラント・インフラ向け機器
                  </Link>
                </div>
              </Stack>
            </div>

            <div className="col-12 py-3 pt-5" id="stamping">
              <div className="sub-inner_headding">
                <h5 className="mb-0">プレス加工品</h5>
              </div>
            </div>
            <div className="col-12 mb-5">
              <Stamping />
            </div>

            <div className="col-12 py-3" id="machining">
              <div className="sub-inner_headding">
                <h5 className="mb-0">切削加工品</h5>
              </div>
            </div>
            <div className="col-12 mb-5">
              <MachiningParts />
            </div>

            <div className="col-12 py-3" id="coloranodized">
              <div className="sub-inner_headding">
                <h5 className="mb-0">アルマイト着色加工品</h5>
              </div>
            </div>
            <div className="col-12 mb-5">
              <ColorAnodized />
            </div>

            {/* <div className="col-12 py-3" id="subprocesses">
              <div className="sub-inner_headding">
                <h5 className="mb-0">Sub Processes</h5>
              </div>
            </div>
            <div className="col-12 mb-5">
              <SubProcesses />
            </div> */}

            <div className="col-12 py-3" id="plantinfrastructure">
              <div className="sub-inner_headding">
                <h5 className="mb-0">プラント・インフラ向け機器</h5>
              </div>
            </div>
            <div className="col-12 mb-5">
              <PlantInfrastructure />
            </div>
          </div>
        </div>
      </div>

      <section className="sub-contact mt-5">
        <div className="sub-contact-inner">
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 0, sm: 0, md: 0 }}
            justifyContent="center"
            alignItems="center"
          >
            <Link href="/instrument">
              <div className="card card-subcontact bg-darkblue">
                <Image
                  loading="lazy"
                  src={SInstru}
                  alt="Instrument Overview"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">設備概要</h1>
                </div>
              </div>
            </Link>
            <Link href="/news">
              <div className="card card-subcontact bg-blue">
                <Image
                  loading="lazy"
                  src={SNews}
                  alt="News"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">ニュース</h1>
                </div>
              </div>
            </Link>
            <Link href="/aboutus">
              <div className="card card-subcontact bg-darkblue">
                <Image
                  loading="lazy"
                  src={SAbout}
                  alt="About Us"
                  className="card-img"
                  width={300}
                />
                <div className="card-img-overlay d-flex justify-content-center align-items-center">
                  <h1 className="mb-0 fw-bold">会社概要</h1>
                </div>
              </div>
            </Link>
          </Stack>
        </div>
      </section>
      <FloatingButton />
      <ScrollToTopFab />
      <Footer />
    </div>
  );
}

export default ProcessUsage;
